import { createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import Config from '../../../Config';
import { buildUrlAndOpenSameWindow } from '../../../utilities/StringHelpers/StringHelpers';
import { getEsimTypeCode, getSimTypeCode } from '../../../utilities/domain/simTypeConstants';
import { cgTypeEnum } from '../../../utilities/enums/cgTypeEnum';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import {setSelectedProducts} from 'app/Components/Block/SaleBlock/saleBlockSlice';
import { createFullLoginStep1, resendOtpStep1, createOtpLoginStep02 } from '../../../utilities/authentication/authenticationSlice';
import { rolesKeys } from '../OTPLoginBlock/Assets/variables';
import { Onboarding } from '../../Page/SelfCarePage/SelfCareAsyncThunk';
import { TAB_ENUM } from '../../Page/SelfCarePage/Constant';
import {
  setIsLoadingShoppingCart,
  setErrorPage,
  setIsSubmit,
  reportAnalytics,
  setOtpDetails,
  goToPage,
  setShowPopUpRouter,
  setUserAddresses,
  setUserAddressesForUpgrade,
  setSelectedUserAddress,
  setOtpAttempts,
  setOtpErrorMsg,
  setOtpRestrictCodeError,
  setOtpTicketId,
  setPersonalInfo,
  setSelectedRouter,
  setCancelRouter,
  setSelectedInternetSpeed,
  setIsCalcSupplyMethod,
  updateConverter,
  setFlowType,
  setSupplyType,
  setTechnicianPrice,
  setDeliveryPrice,
  reportDWH,
  setSelectedAddress,
  setSelectedEntry,
  setIsEmailAvailable,
  setIsOccupiedTechnicianSlot,
  setLeadPage,
  setCellularSettingList,
  resetCellularSettingsPage,
  setDisplaySubscriberBasedPackage,
  setResultByOrders,
  setCellularSetting,
  editRemoveCellular,
  removeCellularItem,
  setFamilyMemberInfo,
  setSalePackages,
  setPackageNotValidPopUp,
  setIdentitySuccessPopup,
  setInternetExistingInternetChoicePopup,
  setAdditionalResultValue
} from './saleJetBlockSlice';
import { callOpenWorkOrderForSaleJet } from '../../../utilities/openWorkOrder';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';
import { getOrgFamilyBenefitsAllocations } from '../../Page/OrgEmployeeFamilySalePage/OrgEmployeeFamilySaleSlice';
import { isOrgEmployeeLogin } from '../../Block/OTPLoginBlock/Assets/variables';
export const getSaleCatalogAsync = createAsyncThunk('saleJetBlock/getSaleCatalogAsync', async (data, thunkAPI) => {
  try {
    const state = thunkAPI.getState().saleJetBlock;

    let orders = [];
    if (state.saleType == 'cellular') {
      orders = state.saleCatalog?.orders ? state.saleCatalog?.orders : [];
    }

    const params = {
      offerId: state.selectedPackage.offerId,
      saleType: state.saleType,
      infraType: state.addressPage.selectedEntry?.infrastructure,
      selectedAddress: {
        internalRequestId: state.addressPage.selectedEntry?.internalRequestId,
        //cellcom | ibc
        siteType: state.addressPage.selectedEntry?.siteType,
        socketStatus: state.addressPage.selectedEntry?.socketStatus,
        //bezeq
        distributionType: state.addressPage.selectedEntry?.distributionType,
        gponBuildingType: state.addressPage.selectedEntry?.gponBuildingType,
        gponExists: state.addressPage.selectedEntry?.gponExists,
        portType: state.addressPage.selectedEntry?.portType,
        maxSpeed: state.addressPage.selectedEntry?.maxSpeed
      },
      general: {
        orderType: state.orderType,
        supplyByPost: state.cellular.isSupplyByPost
      },
      personalInfo: {
        idNumber: state.personalInfo.identity,
        otpPhone: state.personalInfo.subscriberNo,
        accountId: state.checkUserResponse?.accountId,
        isBusinessFamily: state.selectedPackage?.isFamilyPackage
      },
      cellularInfo: {
        cellularType: '',
        cellularNumber: '',
        transferNumber: '',
      },
      addons: state.selectedPackage.addons,
      gisha: [],
      orders: orders,
      productList: [],
      productWorldList: []
    };

    const result = await ProviderManager.getProviderData('getSaleCatalog', params);

    return result?.Body;
  } catch (error) {
    //thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '18521200', isOpenWorkOrder: true, description:'get sale catalog error' }));
  } finally {
  }
});

export const getSalePricesAsync = createAsyncThunk('saleJetBlock/getSalePricesAsync', async (data, thunkAPI) => {
  const state = thunkAPI.getState().saleJetBlock;
  try {
    let currentCellular = null;
    let orders = [];
    if (state.saleType == 'cellular') {
      orders = state.saleCatalog?.orders ? state.saleCatalog?.orders : [];
      currentCellular = state.cellular.cellularSettingsList?.find(x => x.isSelected);
    }

    let productList = [];
    productList.push(
      ...state.converters,
      ...state.selectedAddOns,
      ...state.premiumPackages,
      ...state.productsForUpgrade,
      ...(Object.keys(state.selectedRouter).length === 0 ? [] : [state.selectedRouter]),
      ...(Object.keys(state.selectedInternetSpeed).length === 0 ? [] : [state.selectedInternetSpeed]),
      ...(Object.keys(state.selectedSuperWifi).length === 0 ? [] : [state.selectedSuperWifi])
    );

    const params = {
      offerId: state.selectedPackage.offerId,
      saleType: state.saleType,
      infraType: state.addressPage.selectedEntry?.infrastructure,
      productList: productList,
      calcSupplyMethod: state.isCalcSupplyMethod,
      selectedAddress: {
        internalRequestId: state.addressPage.selectedEntry?.internalRequestId,
        //cellcom | ibc
        siteType: state.addressPage.selectedEntry?.siteType,
        socketStatus: state.addressPage.selectedEntry?.socketStatus,
        //bezeq
        distributionType: state.addressPage.selectedEntry?.distributionType,
        gponBuildingType: state.addressPage.selectedEntry?.gponBuildingType,
        gponExists: state.addressPage.selectedEntry?.gponExists,
        portType: state.addressPage.selectedEntry?.portType,
        maxSpeed: state.addressPage.selectedEntry?.maxSpeed
      },
      general: {
        orderType: state.orderType,
        supplyByPost: state.cellular.isSupplyByPost
      },
      personalInfo: {
        idNumber: state.personalInfo.identity,
        otpPhone: state.personalInfo.subscriberNo,
        accountId: state.checkUserResponse?.accountId,
        isBusinessFamily: state.selectedPackage?.isFamilyPackage
      },
      cellularInfo: {
        cellularType: currentCellular?.simType ?? '',
        cellularNumber: currentCellular?.phoneType == "transfer" ? '' : currentCellular?.phoneNumber,
        transferNumber: currentCellular?.phoneType == "transfer" ? currentCellular?.phoneNumber : '',
        changeCellularNumber: currentCellular?.change?.originalPhoneNumber,
        changeAction: currentCellular?.change?.action,
      },
      addons: state.selectedPackage.addons,
      gisha: currentCellular?.cellularServicesCodes ?? [],
      orders: state.cellular.orders,
      productWorldList: state.productWorldList
    };

    const result = await ProviderManager.getProviderData('getSalePrices', params);

    if (result?.Header?.ReturnCode != 0) {
      if (!data?.silent) {
        thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '18531206', isOpenWorkOrder: true, description: 'get sale prices error' }));
      }
    }
    else{
      if(result?.Body?.successCatalogResult?.isSuccess){
        const saleCatalog = result?.Body.saleCatalog;
        if (state.saleType == 'cellular') {
          thunkAPI.dispatch(getFullPrice({orders: result?.Body.saleCatalog.orders}));
          const bpKey = saleCatalog?.bpKey;
          if(bpKey != null){
            const isExist = state.cellular.simPriceList.find(x => x.bpKey == bpKey);
            if (!isExist || (!isExist?.sim && !isExist?.esim)) {
              await thunkAPI.dispatch(getPriceSim({bpKey : bpKey}));
            }
          }
        }
        else{
          thunkAPI.dispatch(getFullPrice({ params, addonsName: data?.name }))
        }
      }
    }

    return result?.Body;
  } catch (error) {
    //thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '18531205', isOpenWorkOrder: true, description:'get sale prices error' }));
  } finally {
  }
});

export const checkUserAsync = createAsyncThunk('saleJetBlock/checkUserAsync', async (data, thunkAPI) => {
  try {
    const state = thunkAPI.getState().saleJetBlock;

    const params = {
      isCustomerExists: state.personalInfo.isCustomerExists,
      id: state.personalInfo.identity,
      subscriberNo: state.personalInfo.subscriberNo,
      firstName: state.personalInfo.firstName,
      lastName: state.personalInfo.lastName,
      saleType: state.saleType,
      isReplaceMode: state.saleBlockData.isAllowReplace,
      isOfferFamilyPackage: state.selectedPackage?.isFamilyPackage
    };

    const result = await ProviderManager.getProviderData('checkUser', params);

    return result?.Body;
  } catch (error) {
  } finally {
  }
});

export const prepareSaleAsync = createAsyncThunk('saleJetBlock/prepareSaleAsync', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    let state = thunkAPI.getState().saleJetBlock;
    const authenticationState = thunkAPI.getState().authentication;
    const skipCheckUser =
      state.saleType === 'internet' &&
      !authenticationState.loginData?.isFullAuthenticated &&
      !state.personalInfo?.identity;

    let tasks = [thunkAPI.dispatch(getSaleCatalogAsync())];
    if (!skipCheckUser) {
      tasks.push(thunkAPI.dispatch(checkUserAsync()));
    }

    if (state.saleBlockData.isAllowReplace && !skipCheckUser) {
      tasks.push(thunkAPI.dispatch(getUserAddressesForUpgrade()));
    }

    await Promise.all(tasks);

    state = thunkAPI.getState().saleJetBlock;

    if (!state.saleCatalog || Object.keys(state.saleCatalog).length === 0) {
      thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '18521200', isOpenWorkOrder: true, description: 'get sale catalog error' }));
      return;
    }

    if (state.saleType == 'cellular') {
      const bpKey = state.saleCatalog?.bpKey;
      const isExist = state.cellular.simPriceList.find(x => x.bpKey == bpKey);
      if (!isExist || (!isExist?.sim && !isExist?.esim)) {
        await thunkAPI.dispatch(getPriceSim({bpKey: bpKey}));
      }
    }

    if (
      state.selectedPackage.defaultConvertersAmount > 0 &&
      state.selectedPackage.defaultConvertersAmount <= state.saleBlockData.maximumConverters
    ) {
      const converters = state.saleCatalog?.converters.filter((x) => x.name == 'PREM');
      if (converters) {
        const data = { name: 'PREM', count: state.selectedPackage.defaultConvertersAmount };
        thunkAPI.dispatch(updateConverter(data));
      }
    }

    if (!skipCheckUser && state.checkUserResponse?.isInBlackList) {
      thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '17', isOpenWorkOrder: true, description: 'is in black list error' }));
      thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'prepare sale error: isInBlackList' }));
      return;
    }

    if (!skipCheckUser && !state.checkUserResponse?.canPerformJetSale) {
      let error = state.checkUserResponse.jetSaleReason
      let errorDescription = "";
      switch (error) {
        case "DENAY_TRIPLE_TVORINTERNET_EXIST":
          errorDescription = "כישלון רכישת טריפל - אינטרנט  או tv קיימים כבר";
          break;
        case "DENAY_ALL_OTHERS":
          errorDescription = "לקוח עם מוצר נייח שלם הוסב ל JET";
          break;

      }
      thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '75', isOpenWorkOrder: true, description: errorDescription }));
      thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'prepare sale error: canPerformJetSale' }));
      return;
    }

    if (state.saleType == 'internet' || state.saleType == 'triple') {
      if (state.selectedPackage.selectedRouterName) {
        const selectedRouter = state.saleCatalog.routers.find((x) => x.name == state.selectedPackage.selectedRouterName);
        if (selectedRouter) {
          thunkAPI.dispatch(setSelectedRouter({ name: selectedRouter.name }));
        } else {
          const cellcomRouter = state.saleCatalog.routers.find((x) => x.isForeignRouter == false);
          if (cellcomRouter) {
            thunkAPI.dispatch(setSelectedRouter({ name: cellcomRouter.name }));
          }
        }
      }



      const internetSpeedToChoose = state.saleCatalog.internetSpeedList.find((x) => x.downloadSpeed == state.selectedPackage?.downloadSpeed && x.uploadSpeed == state.selectedPackage?.uploadSpeed);
      if (internetSpeedToChoose) {
        thunkAPI.dispatch(setSelectedInternetSpeed({ name: internetSpeedToChoose.name }));
      } else {
        thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '75', isOpenWorkOrder: true, description: 'מהירות אינטרנט אינה תואמת' }));
        thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'prepare sale error: internetSpeed not match' }));
        return;
      }

    }

    if (state.saleType != 'cellular') {
      await thunkAPI.dispatch(getSalePricesAsync());
      state = thunkAPI.getState().saleJetBlock;
      if (!state.saleCatalog || Object.keys(state.saleCatalog).length === 0) {
        thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '18521200', isOpenWorkOrder: true, description: 'get sale catalog error' }));
        thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'prepare sale error: get sale catalog' }));
        return;
      }

      if (state.userAddressForUpgradePage.userAddresses.length > 0) {
        thunkAPI.dispatch(goToPage('userAddressForUpgradePage'));
        return;
      }
    }


    thunkAPI.dispatch(goToNextPage());
  } catch (error) {
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const addRouterWifiStarPro = createAsyncThunk('saleJetBlock/addRouterWifiStarPro', async (data, thunkAPI) => {
  const state = thunkAPI.getState().saleJetBlock;
  let countRouters = state.saleCatalog.routers.filter((x) => x.action === 'Add');
  if(countRouters.length > 0){
    countRouters.forEach(element => {
      thunkAPI.dispatch(setCancelRouter({ name: element.name }));
    });
  };
  const nameRouterUpgrade = state.selectedPackage.routerInfo.nameRouterUpgrade.value;
  const routersWifi = state.saleCatalog.routers?.find(x => x.name === nameRouterUpgrade);
  thunkAPI.dispatch(setSelectedRouter({ name: routersWifi.name }));
  await thunkAPI.dispatch(getSalePricesAsync());
  thunkAPI.dispatch(goToNextPage());
});

export const prepareSaleReplaceAsync = createAsyncThunk('saleJetBlock/prepareSaleReplaceAsync', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    let state = thunkAPI.getState().saleJetBlock;

    if (!state.addressPage.selectedAddress || Object.keys(state.addressPage.selectedAddress).length === 0) {
      const selectedAddress = {
        cityCode: state.userAddressForUpgradePage.selectedAddress.productAddress.cityCode,
        cityName: state.userAddressForUpgradePage.selectedAddress.productAddress.cityName,
        streetCode: state.userAddressForUpgradePage.selectedAddress.productAddress.streetCode,
        streetName: state.userAddressForUpgradePage.selectedAddress.productAddress.streetName,
        home: state.userAddressForUpgradePage.selectedAddress.productAddress.houseNumber,
        floor: '1',
        entry: '',
        apartment: state.userAddressForUpgradePage.selectedAddress.productAddress.apartment,
        zipCode: state.userAddressForUpgradePage.selectedAddress.productAddress.zipCode,
      };
      const selectedEntry = {
        gponBuildingType: '',
        distributionType: '',
        socketStatus: '',
        siteType: '',
        gponExists: '',
        portType: '',
        internalRequestId: '',
        infrastructure: state.userAddressForUpgradePage.selectedAddress.infrastructure,
        packageRateCode: '',
        entry: '',
      };
      thunkAPI.dispatch(setSelectedAddress(selectedAddress));
      thunkAPI.dispatch(setSelectedEntry(selectedEntry));
    }

    await Promise.all([thunkAPI.dispatch(getSaleCatalogAsync()) /*, thunkAPI.dispatch(checkUserAsync())*/]);
    state = thunkAPI.getState().saleJetBlock;

    if (!state.saleCatalog || Object.keys(state.saleCatalog).length === 0) {
      thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '18521200', isOpenWorkOrder: true, description: 'get sale catalog error' }));
      return;
    }

    if (state.selectedPackage?.defaultConvertersAmount > 0 && state.selectedPackage?.defaultConvertersAmount <= state.saleBlockData?.maximumConverters) {
      const converters = state.saleCatalog?.converters?.filter((x) => x.name == 'PREM');
      if (converters) {
        const data = { name: 'PREM', count: state.selectedPackage?.defaultConvertersAmount };
        thunkAPI.dispatch(updateConverter(data));
      }
    }

    if (state.saleType == 'internet' || state.saleType == 'triple') {
      if (state.selectedPackage?.selectedRouterName) {
        const selectedRouter = state.saleCatalog?.routers?.find((x) => x.name == state.selectedPackage?.selectedRouterName);
        if (selectedRouter) {
          thunkAPI.dispatch(setSelectedRouter({ name: selectedRouter.name }));
        } else {
          const cellcomRouter = state.saleCatalog?.routers?.find((x) => x.isForeignRouter == false);
          if (cellcomRouter) {
            thunkAPI.dispatch(setSelectedRouter({ name: cellcomRouter.name }));
          }
        }
      }

      const internetSpeedToChoose = state.saleCatalog?.internetSpeedList?.find((x) => x.downloadSpeed == state.selectedPackage?.downloadSpeed && x.uploadSpeed == state.selectedPackage?.uploadSpeed);
      if (internetSpeedToChoose) {
        thunkAPI.dispatch(setSelectedInternetSpeed({ name: internetSpeedToChoose.name }));
      } else {
        thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '75', isOpenWorkOrder: true, description: 'מהירות אינטרנט אינה תואמת' }));
        thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'prepare sale error: internetSpeed not match' }));
        return;
      }
    }
    await thunkAPI.dispatch(getSalePricesAsync());
    state = thunkAPI.getState().saleJetBlock;

    if (!state.saleCatalog || Object.keys(state.saleCatalog).length === 0) {
      thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '18521200', isOpenWorkOrder: true, description: 'get sale catalog error' }));
      thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'prepare sale error: get sale catalog' }));
      return;
    }

    thunkAPI.dispatch(goToNextPage());
  } catch (error) {
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const goToNextPage = createAsyncThunk('saleJetBlock/goToNextPage', async (data, thunkAPI) => {
  const state = thunkAPI.getState().saleJetBlock;
  const isHidePremiumPackagesPage = state.saleBlockData.isHidePremiumPackagesPage;
  switch (state.saleType) {
    case 'tv':
      if (state.selectedPackage?.defaultConvertersAmount > 0 || state.selectedPackage?.minimumConvertersAmount > 0) {
        thunkAPI.dispatch(goToPage('convertersPage'));
      } else {
        thunkAPI.dispatch(goToPage('viewingOptionPage'));
      }
      break;
    case 'app':
      if(isHidePremiumPackagesPage){
          if (state.saleCatalog?.addons?.length >= 1){
            thunkAPI.dispatch(goToPage('addonsPage'));
          }else if (state.flowType == 'existsCustomer') {
            thunkAPI.dispatch(getCustomerAddresses());
          }
          else {
            thunkAPI.dispatch(goToPage('personalInfoPage'));
          }
      }else{
        thunkAPI.dispatch(goToPage('premiumPackagesPage'));
      }
      break;
    case 'cellular':
      thunkAPI.dispatch(resetCellularSettingsPage({ isFullReset: true }));
      thunkAPI.dispatch(goToPage('cellularSettingsPage'));
      break;
    case 'internet':
    case 'triple':
      const hasSelectedRouter = state.saleCatalog?.routers?.find((x) => x.action == 'Add');
      if (!hasSelectedRouter) {
        thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '75', isOpenWorkOrder: true, description: 'לא נבחר ראוטר' }));
        //thunkAPI.dispatch(goToPage('routerPage'));
      } else {
        const hasSuperWifi = state.saleCatalog?.superWifiList?.find((x) => x.action == 'Add');
        const displaySuperWifi = (state.selectedPackage?.downloadSpeed != 2500);
        const foreignRouter = state.saleCatalog.routers?.find((x) => x.action == 'Add' && x.name == 'NATAVT');
        if(!foreignRouter){
          const nameRouterUpgrade = state.selectedPackage.routerInfo.nameRouterUpgrade.value;
          const wifiRouter = state.saleCatalog.routers?.find((x) => x.name == nameRouterUpgrade);
          if(wifiRouter){
              thunkAPI.dispatch(setShowPopUpRouter(true));
          };
        };

        if ((state.orderType == 'provide' && state.saleBlockData?.isDisplaySuperWifi) || (state.orderType == 'replace' && hasSuperWifi && displaySuperWifi)) {
          thunkAPI.dispatch(goToPage('superWifiPage'));
        } else {
          if (state.saleType == 'triple') {
            thunkAPI.dispatch(goToPage('convertersPage'));
          }
          else {
            if (state.saleCatalog.addons.length >= 1 ) { //internet
              thunkAPI.dispatch(goToPage('addonsPage'));
            } else if (thunkAPI.getState().authentication?.loginData?.isFullAuthenticated) {
              // Already identified — no need for the customer info / OTP screen
              thunkAPI.dispatch(continueAfterInternetIdentityAsync());
            } else {
              thunkAPI.dispatch(goToPage('internetCustomerInfoPage'));
            };
          }
        }
      }
      break;
  }
});

export const setSelectedProductsAsync = createAsyncThunk('saleJetBlock/setSelectedProductsAsync', async (data, thunkAPI) => {
  thunkAPI.dispatch(setSelectedProducts());
  const state = thunkAPI.getState().saleJetBlock;
  const eventLabel = state.productsInfo.selectedProducts[0]?.name;
  thunkAPI.dispatch(
    reportAnalytics({
      eventCategory: 'tv_newsale_process',
      eventAction: state.flowType == 'existsCustomer' ? 'click_9' : 'click_22',
      eventLabel: eventLabel,
    })
  );
});

function isRestrictedCodeRequired(body) {
  const codeError = parseInt(body?.codeError, 10);
  return codeError === 31 || codeError === 75 || body?.resultMessage === 'OTP_RESTRICT_CODE_REQUIRE';
}

export const createOtpForNewCustomerAsync = createAsyncThunk('saleJetBlock/createOtpForNewCustomerAsync', async (data, thunkAPI) => {
  const state = thunkAPI.getState().saleJetBlock;

  try {
    const contactNumber = data.contactNumber;
    const identity = data.identity;

    if (contactNumber && identity) {
      let useGuestOtp = false;
      let needsPaymentDigits = false;

      // Fiber: try full login OTP first (creates auth_token for existing customers)
      if (state.saleType === 'internet' && data.otpFlow === 'internetCustomerInfo') {
        try {
          thunkAPI.dispatch(showAppLoader());
          const loginStep1 = await thunkAPI.dispatch(
            createFullLoginStep1({
              phoneNumber: contactNumber,
              idNumber: identity,
              digits: '',
              originProcess: '',
            }),
          );

          if (createFullLoginStep1.fulfilled.match(loginStep1)) {
            const body = loginStep1.payload?.Body;
            const codeError = parseInt(body?.codeError, 10);

            if ([32, 33].includes(codeError)) {
              // Phone/ID mismatch: first verify the entered phone with OTP, then 4 payment digits
              useGuestOtp = true;
              needsPaymentDigits = true;
            } else if (body?.isSuccess && [0, 30, 31, 71, 75].includes(codeError) && body?.message) {
              thunkAPI.dispatch(
                setOtpDetails({
                  otpTicketId: body.message,
                  otpPhone: contactNumber,
                  otpIdentity: identity,
                  otpFlow: 'internetCustomerInfo',
                  customerEmail: body?.extra?.customerEmail || '',
                  restrictedCodeRequired: isRestrictedCodeRequired(body),
                }),
              );
              thunkAPI.dispatch(goToPage('otpVerifyCode'));
              return body;
            } else {
              useGuestOtp = true;
              thunkAPI.dispatch(setFlowType('newCustomer'));
              thunkAPI.dispatch(
                reportDWH({
                  actionType: 'Customer Info',
                  status: 'Ongoing',
                  messageText: 'LoginStep1Full missed — continue with guest OTP (new customer)',
                }),
              );
            }
          } else {
            useGuestOtp = true;
            thunkAPI.dispatch(setFlowType('newCustomer'));
            thunkAPI.dispatch(
              reportDWH({
                actionType: 'Customer Info',
                status: 'Ongoing',
                messageText: 'LoginStep1Full missed — continue with guest OTP (new customer)',
              }),
            );
          }
        } catch (error) {
          useGuestOtp = true;
          thunkAPI.dispatch(setFlowType('newCustomer'));
          thunkAPI.dispatch(
            reportDWH({
              actionType: 'Customer Info',
              status: 'Ongoing',
              messageText: 'LoginStep1Full exception — continue with guest OTP (new customer)',
            }),
          );
        } finally {
          thunkAPI.dispatch(hideAppLoader());
        }

        if (!useGuestOtp) {
          return;
        }
      }

      let step1Ticket = '';
      //------------ createOtp ------------
      try {
        thunkAPI.dispatch(showAppLoader());
        const result = await ProviderManager.getProviderData('createOtp', [contactNumber, false]);
        if (result.Body && result.Body.step1Ticket) {
          step1Ticket = result.Body.step1Ticket;
        }
      } catch (error) {
      } finally {
        thunkAPI.dispatch(hideAppLoader());
      }
      //------------ createOtp ------------
      if (step1Ticket && step1Ticket != '') {
        const otpFlow =
          state.saleType === 'internet'
            ? useGuestOtp
              ? 'internetCustomerInfoGuest'
              : data.otpFlow
            : undefined;
        thunkAPI.dispatch(setOtpDetails({
          otpTicketId: step1Ticket,
          otpPhone: contactNumber,
          otpIdentity: identity,
          otpFlow,
          needsPaymentDigits,
        }));
        thunkAPI.dispatch(goToPage('otpVerifyCode'));
      } else {
        thunkAPI.dispatch(
          setErrorPage({ isDisplay: true, id: '75', isOpenWorkOrder: true, description: 'שגיםה בקבלת קוד otp' })
        );
        thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'create otp for new customer error: step1Ticket' }));
      }
    } else {
      thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '75', isOpenWorkOrder: true, description: 'שגיםה בשלב הזנת קוד otp' }));
      thunkAPI.dispatch(
        reportDWH({ actionType: 'Error', status: 'Error', messageText: 'create otp for new customer error: no contactNumber or identity' })
      );
    }
  } catch (error) { }
});

export const validateInternetPaymentDigitsAsync = createAsyncThunk(
  'saleJetBlock/validateInternetPaymentDigitsAsync',
  async (digits, thunkAPI) => {
    try {
      const state = thunkAPI.getState().saleJetBlock;

      const action = await thunkAPI.dispatch(
        createFullLoginStep1({
          phoneNumber: state.otpDetails.otpPhone,
          idNumber: state.otpDetails.otpIdentity,
          digits,
          originProcess: '',
        }),
      );

      if (createFullLoginStep1.rejected.match(action)) {
        return thunkAPI.rejectWithValue(
          action.error?.message ?? 'payment digits validation failed',
        );
      }

      const body = action.payload?.Body;

      if (body?.isSuccess !== true) {
        return thunkAPI.rejectWithValue(body);
      }

      const codeError = parseInt(body?.codeError, 10);
      if (![0, 30, 31, 71, 75].includes(codeError)) {
        return thunkAPI.rejectWithValue(body);
      }

      return {
        ...body,
        restrictedCodeRequired: isRestrictedCodeRequired(body),
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.message ?? 'payment digits validation failed',
      );
    }
  },
);

export const getEMVStep1 = createAsyncThunk('saleJetBlock/getEMVStep1', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const state = thunkAPI.getState().saleJetBlock;
    let totalPrice = state.totalPrice && state.totalPrice != '' ? state.totalPrice : '0';
    const type = cgTypeEnum.CHECKCARD;
    let customerId = '0';

    if (Config.cgShowIdNumber == 'True' && state.personalInfo.identity) {
      customerId = state.personalInfo.identity;
    }

    const result = await ProviderManager.getProviderData('getCGEMVStep1', [type, customerId, totalPrice, '1', 'saleJet', false,"PaymentSaleJet"]);
    return result.Body;
  } catch (error) {
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const getEMVStep2 = createAsyncThunk('saleJetBlock/getEMVStep2', async (data, thunkAPI) => {
  try {
    const state = thunkAPI.getState().saleJetBlock;
    const totalPrice = state.totalPrice && state.totalPrice != '' ? state.totalPrice : '100';
    const blockId = state.saleBlockData.blockId;
    const isShowIdNumber = Config.cgShowIdNumber;
    const type = cgTypeEnum.CHECKCARD;
    let customerId = data.id;
    const result = await ProviderManager.getProviderData('getCGEMVStep2', [
      totalPrice,
      data.token,
      type,
      isShowIdNumber,
      customerId,
      blockId,
      'saleJet',
      false,
      'SaleJetBlock'
    ]);
    return result.Body;
  } catch (error) {
    return error;
  }
});

export const checkFiberAddressInfraStructure = createAsyncThunk('saleJetBlock/checkFiberAddressInfraStructure', async (data, thunkAPI) => {
  try {
    const state = thunkAPI.getState().saleJetBlock;
    const entry = state.addressPage.selectedAddress.entry;
    let entryRequest = entry == "ללא שם" ? "NONE" : (entry == null || entry == '') ? ' ' : entry;
    const result = await ProviderManager.getProviderData('checkFiberAddressInfraStructure', [
      state.addressPage.selectedAddress.cityName,
      state.addressPage.selectedAddress.citySemel,
      state.addressPage.selectedAddress.streetName,
      state.addressPage.selectedAddress.streetSemel,
      (state.addressPage.selectedAddress.streetGisSemel ? state.addressPage.selectedAddress.streetGisSemel : '0'),
      state.addressPage.selectedAddress.home,
      entryRequest,
      state.addressPage.selectedAddress.apartment,
    ]);
    return result;
  } catch (error) {
    return error;
  }
});

export const getAddressEntries = createAsyncThunk('saleJetBlock/getAddressEntries', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const state = thunkAPI.getState().saleJetBlock;
    const result = await ProviderManager.getProviderData('getAddressEntries', [
      state.addressPage.selectedAddress.cityCode,
      state.addressPage.selectedAddress.streetCode,
      state.addressPage.selectedAddress.home,
    ]);
    return result;
  } catch (error) {
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

// Existing / separate-invoice paths only — not used for newCustomer (state starts empty).
export const enterInternetAddPaymentMode = () => (dispatch) => {
  dispatch(
    setSelectedUserAddress({
      address: {},
      isSelectedSeparateInvoice: true,
    }),
  );
  dispatch(goToPage('internetExistingPaymentPage'));
};

export const getCustomerAddresses = createAsyncThunk('saleJetBlock/getCustomerAddresses', async (data, thunkAPI) => {
  let actionType = '';
  try {
    const state = thunkAPI.getState().saleJetBlock;
    const isCustomerBasedPackage = state.selectedPackage?.isCustomerBasedPackage;
    const isFamilyPackage = state.selectedPackage?.isFamilyPackage;
    const bpKey = state.saleCatalog?.bpKey;
    actionType = getActionTypeByPage(state.page);

    if (state.orderType == 'replace') {
      const hasTv = state.userAddressForUpgradePage.selectedAddress?.products?.find((x) => x.type.toLowerCase() == 'tv');
      if (!hasTv) {
        thunkAPI.dispatch(goToPage('emailPage'));
      } else {
        thunkAPI.dispatch(goToPage('createSaleInProcess'));
      }
      return;
    }

    let request = {
      saleType: state.saleType,
      isCustomerBasedPackage: isCustomerBasedPackage, // for cellular
      isOfferFamilyPackage: isFamilyPackage,
      bpKey: bpKey // for cellular
    }

    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('getJetCustomerAddresses', request);

    if (!result.Body || result.Body.length == 0) {
      if (state.saleType === 'internet') {
        thunkAPI.dispatch(enterInternetAddPaymentMode());
      } else {
        thunkAPI.dispatch(setFlowType('newCustomer'));
        thunkAPI.dispatch(goToPage('personalInfoPage'));
      }
      thunkAPI.dispatch(reportDWH({ actionType: actionType, status: 'Ongoing', messageText: 'No Bans To Display Found' }));
      return;
    }else{
      if(state.saleType == 'cellular' && isFamilyPackage){
        if(result.Body?.length == 1 ){
          thunkAPI.dispatch(setFamilyMemberInfo(result.Body[0]?.additionalInfo));
          if((result.Body[0]?.additionalInfo?.banId == null || result.Body[0]?.additionalInfo?.banId == '')){
            thunkAPI.dispatch(setFlowType('newCustomer'));
            thunkAPI.dispatch(goToPage('personalInfoPage'));
            thunkAPI.dispatch(reportDWH({ actionType: actionType, status: 'Ongoing', messageText: 'No Bans To Display Found' }));
            return;
          }
        }
      }
    }

    thunkAPI.dispatch(setUserAddresses(result.Body));
    thunkAPI.dispatch(goToPage(state.saleType === 'internet' ? 'internetExistingPaymentPage' : 'userAddressPage'));

    return result;
  } catch (error) {
    thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '75', isOpenWorkOrder: true, description: 'שגיםה בקבלת כתובת לקוח' }));
    thunkAPI.dispatch(reportDWH({ actionType: actionType, status: 'Error', messageText: 'No Bans To Display Found' }));
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const getUserAddressesForUpgrade = createAsyncThunk('saleJetBlock/getUserAddressesForUpgrade', async (data, thunkAPI) => {
  try {
    const state = thunkAPI.getState().saleJetBlock;

    const result = await ProviderManager.getProviderData('getReplacedBansBySaleType', [state.saleType]);

    if (result.Body && result.Body.bansForReplace.length > 0) {
      thunkAPI.dispatch(setUserAddressesForUpgrade(result.Body));
    }
    return result.Body;
  } catch (error) {
  } finally {
  }
});

export const continueAfterInternetIdentityAsync = createAsyncThunk(
  'saleJetBlock/continueAfterInternetIdentityAsync',
  async (_, thunkAPI) => {
    const subscribersByProduct = thunkAPI.getState().selfcarePage?.subscribersByProduct;
    const hasOnboardingData = Boolean(subscribersByProduct && !Array.isArray(subscribersByProduct));
    if (!hasOnboardingData) {
      await thunkAPI.dispatch(Onboarding());
    }

    const internetSubscribers =
      thunkAPI.getState().selfcarePage?.subscribersByProduct?.[TAB_ENUM.Internet] || [];
    const hasExistingInternet = internetSubscribers.length > 0;

    if (hasExistingInternet) {
      thunkAPI.dispatch(setInternetExistingInternetChoicePopup({ isDisplay: true }));
      return { hasExistingInternet: true };
    }

    await thunkAPI.dispatch(getTechnicianTimesAsync());
    return { hasExistingInternet: false };
  },
);

export const createSaleAsync = createAsyncThunk('saleJetBlock/createSaleAsync', async (data, thunkAPI) => {
  //thunkAPI.dispatch(showAppLoader());
  const state = thunkAPI.getState().saleJetBlock;
  try {

    let currentCellular = null;
    let calcSupplyMethod = false;
    let orders = [];
    let familyPackageObj = {};
    let couponList = [];
    if (state.saleType == 'cellular') {
      currentCellular = state.cellular.cellularSettingsList?.find(x => x.isSelected);
      calcSupplyMethod = state.cellular.isDisplayDeliveryPage;
      orders = state.saleCatalog?.orders ? state.saleCatalog?.orders : [];
      const isFamilyPackage = state.selectedPackage?.isFamilyPackage;
      if(isFamilyPackage){
        familyPackageObj.isOfferFamilyPackage = isFamilyPackage;
        familyPackageObj.accountType = state.familyMemberInfo.accountType;
        familyPackageObj.accountMidType = state.familyMemberInfo.accountMidType;
        familyPackageObj.accountSubType = state.familyMemberInfo.accountSubType;
        familyPackageObj.parentId = state.familyMemberInfo?.parentId;
        familyPackageObj.productId = state.selectedPackage?.familyPackageSapFields?.productID;
        familyPackageObj.productIdPortIn = state.selectedPackage?.familyPackageSapFields?.productIDPortIn;
        familyPackageObj.bpKey = state.selectedPackage?.familyPackageSapFields?.bpKey;
        familyPackageObj.package = state.selectedPackage?.familyPackageSapFields?.package;
        familyPackageObj.packagePortIn = state.selectedPackage?.familyPackageSapFields?.packagePortIn;
        familyPackageObj.combSeq = state.selectedPackage?.familyPackageSapFields?.combSeq;
        familyPackageObj.combSeqPortIn = state.selectedPackage?.familyPackageSapFields?.combSeqPortIn;
        familyPackageObj.zterm = state.selectedPackage?.familyPackageSapFields?.zterm;
      }

      state.cellular.cellularSettingsList.map(item => {
        const couponNameList = item.package.couponList?.map(coupon => coupon.couponType.value);
        if(couponNameList?.length > 0){
            couponList.push({couponName: couponNameList , offerId: item.package.offerId });
        }
      })

    }else{
        const couponNameList = state.selectedPackage.couponList?.map(coupon => coupon.couponType.value);
        if(couponNameList?.length > 0){
            couponList.push({couponName: couponNameList , offerId: state.selectedPackage.offerId });
        }
    }

    let productList = [];
    productList.push(
      ...state.converters,
      ...state.premiumPackages,
      ...state.productsForUpgrade,
      ...state.selectedAddOns,
      ...(Object.keys(state.selectedRouter).length === 0 ? [] : [state.selectedRouter]),
      ...(Object.keys(state.selectedInternetSpeed).length === 0 ? [] : [state.selectedInternetSpeed]),
      ...(Object.keys(state.selectedSuperWifi).length === 0 ? [] : [state.selectedSuperWifi])
    );

    // let maxSpeed = '';
    // if (state.saleType == 'internet' || state.saleType == 'triple') {
    //   maxSpeed = state.addressPage.selectedEntry?.infrastructure == 'BC' ? '1000' : '2500';
    // }

    let supplyMethod = 'No Supply';
    if (state.supplyType == 'technician' || state.supplyType == 'delivery') {
      supplyMethod = state.supplyType.charAt(0).toUpperCase() + state.supplyType.slice(1);
    }

    const selectedBanId =
      state.orderType == 'replace'
        ? state.userAddressForUpgradePage.selectedAddress?.ban
        : state.userAddressPage.selectedAddress?.additionalInfo?.banId;
    const shouldCreateNewBan = Boolean(
      !selectedBanId &&
        state.checkUserResponse?.accountId &&
        state.paymentInfo?.CCToken,
    );
    // 1443 requires bill delivery when opening a BAN with invoice email (add-payment flow).
    const isReceivingBillForCreateBan =
      shouldCreateNewBan && Boolean(state.personalInfo.email?.trim())
        ? true
        : state.personalInfo.isReceivingBill;

    let params = {
      saleType: state.saleType,
      offerId: state.selectedPackage.offerId,
      bpkey: state.saleCatalog?.bpKey,
      infraType: state.addressPage.selectedEntry?.infrastructure,
      internetSpeed: state.selectedPackage.internetSpeed,
      productList: productList,
      calcSupplyMethod: calcSupplyMethod,
      general: {
        supplyMethod: supplyMethod, //Technician|Delivery|No Supply|SelfPickUp
        supplyByPost: state.cellular.isSupplyByPost,
        calcPriceInd: false,
        orderType: state.orderType,
        serviceAction: 'ADD', //ADD/REMOVE
        billingAccountIdType: 'I',
      },
      customerExposure: {
        decisionSeq: state.checkUserResponse.customerExposure?.decisionSeq,
        isKosher: state.checkUserResponse?.isKosherSubscriber,
        isCellularPhone: !state.checkUserResponse?.collectEmailOnProcess,
        summaryEmail: state.personalInfo.email,
      },
      selectedAddress: {
        city: state.addressPage.selectedAddress?.citySemel,
        cityName: state.addressPage.selectedAddress?.cityName,
        street: state.addressPage.selectedAddress?.streetSemel,
        streetName: state.addressPage.selectedAddress?.streetName,
        streetGisSemel: state.addressPage.selectedAddress?.streetGisSemel,
        houseNumber: state.addressPage.selectedAddress?.home,
        aptNumber: state.addressPage.selectedAddress?.apartment,
        entrance: state.addressPage.selectedAddress?.entry,
        floor: state.addressPage.selectedAddress?.floor,
        postalCode: state.addressPage.selectedAddress?.zipCode,
        isChanged: false,
        updateCustomerAddress: false,
        tashtitType: state.addressPage.selectedEntry?.infrastructure,
        gponBuildingType: state.addressPage.selectedEntry?.gponBuildingType,
        distributionType: state.addressPage.selectedEntry?.distributionType,
        socketStatus: state.addressPage.selectedEntry?.socketStatus,
        siteType: state.addressPage.selectedEntry?.siteType,
        gponExists: state.addressPage.selectedEntry?.gponExists,
        portType: state.addressPage.selectedEntry?.portType,
        internalRequestId: state.addressPage.selectedEntry?.internalRequestId,
        maxSpeed: state.addressPage.selectedEntry?.maxSpeed,
        infrastructure: state.addressPage.selectedEntry?.infrastructure,
        packageRateCode: state.addressPage.selectedEntry?.packageRateCode,
        changeSpeedInd: false, // ב PROVIDE יש לשלוח FALSE
        bezeqFiberExist: false, // ממשק 1445 איתור לקוח - אם אותו לקוח בבזק סיבים יש לשלוח את הערך true אם לא אותו לקוח יש לשלוח false
        seq: '', //seq from 1445
        technologyType: state.addressPage.selectedEntry?.technologyType
      },
      workAddress: {
        cityName: state.delivery.selectedAddress?.cityName,
        streetName: state.delivery.selectedAddress?.streetName,
        houseNumber: state.delivery.selectedAddress?.home,
        aptNumber: state.delivery.selectedAddress?.apartment,
      },
      personalInfo: {
        isCustomerExists:
          state.personalInfo.isCustomerExists || Boolean(state.checkUserResponse?.accountId),
        // Existing Jet customer, no selected BAN, new card token => open a new BAN in Sale (1443/1855).
        createNewBan: shouldCreateNewBan,
        ban: selectedBanId, //מספר BAN שנוצר בממשק 1443 / שנבחר למכירה
        accountId: state.checkUserResponse?.accountId, // מספר לקוח JET כפי שקיבלנו מP&S או מממשק 1855
        idNumber: state.personalInfo.identity, // ת.ז. של  איש הקשר הראשי - זו שהוזנה בזיהוי
        otpPhone: state.personalInfo.subscriberNo,
        isReceivingAd: state.personalInfo.isReceivingAd,
        isReceivingBill: isReceivingBillForCreateBan,
        email: state.personalInfo.email,
        firstName: state.personalInfo.firstName,
        lastName: state.personalInfo.lastName,
        paymentCardDueYear: state.paymentInfo.CardDueYear,
        paymentCardDueMonth: state.paymentInfo.CardDueMonth,
        paymentCcType: state.paymentInfo.CCType,
        paymentCcToken: state.paymentInfo.CCToken,
        paymentAuthNumber: state.paymentInfo.confirmationNumber,
        paymentTerminalNumber: 'CheckCard',
        isBusinessFamily: state.selectedPackage?.isFamilyPackage
      },
      techVisitInfo: {
        startDate:
          state.supplyType == 'technician'
            ? state.technician.selectedTechnicianTime.startDate
            : state.delivery.selectedDeliveryDate.startDate,
        endDate:
          state.supplyType == 'technician' ? state.technician.selectedTechnicianTime.endDate : state.delivery.selectedDeliveryDate.endDate,
        round: state.supplyType == 'technician' ? '' : state.delivery.selectedDeliveryDate.round,
      },
      haveTechnicianVisit: true,
      cellularInfo: {
        cellularType: currentCellular?.simType ?? '',
        cellularNumber: currentCellular?.phoneNumber ?? '',
        transferNumber: currentCellular?.phoneType == "transfer" ? currentCellular.phoneNumber : '',
      },
      addons: state.selectedPackage.addons,
      gisha: currentCellular?.cellularServicesCodes ?? [],
      orders: state.cellular.orders,
      corpInfo: familyPackageObj,
      epiInfo: {
        urlActivateEsimPage : state.saleBlockData.urlActivateEsimPage,
      },
      couponServiceList : couponList
    };

    if (state.saleType == 'app' && state.flowType == 'existsCustomer') {
      params.selectedAddress.city = state.userAddressPage.selectedAddress?.cityCode;
      params.selectedAddress.cityName = state.userAddressPage.selectedAddress?.cityName;
      params.selectedAddress.street = state.userAddressPage.selectedAddress?.streetCode;
      params.selectedAddress.streetName = state.userAddressPage.selectedAddress?.streetName;
      params.selectedAddress.houseNumber = state.userAddressPage.selectedAddress?.home;
      params.selectedAddress.aptNumber = state.userAddressPage.selectedAddress?.apartment;
      params.selectedAddress.postalCode = state.userAddressPage.selectedAddress?.zipCode;
    }

    //thunkAPI.dispatch(goToPage('successPage'));
    //return { isSuccess: true, orderId: '11111' };

    const result = await ProviderManager.getProviderData('createSale', params);

    if (result.Header?.ReturnCode == 0 && result.Body?.isSuccess) {
      thunkAPI.dispatch(setResultByOrders(result.Body.resultByOrders));
      thunkAPI.dispatch(setAdditionalResultValue(result.Body.additionalResultValue));
      thunkAPI.dispatch(goToPage('successPage'));
      reportDWHCreateSale(thunkAPI, state.saleType, 'Success');
    } else {
      if (result.Body?.codeError == '16831550') {
        // thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: result.Body.codeError, isOpenWorkOrder: true, description: 'technician busy new date needed' }));
        // reportDWHCreateSale(thunkAPI, state.saleType, 'Technician Busy New Date Needed');
        thunkAPI.dispatch(setIsOccupiedTechnicianSlot(true));
        thunkAPI.dispatch(getTechnicianTimesAsync());
      } else {
        if(result.Body?.codeError.includes('6030')) {
          thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: result.Body.codeError, isOpenWorkOrder: false, description: 'נראה שההטבה הסתיימה ולא ניתן לממש אותה יותר' }));
        }else{
          thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: result.Body.codeError, isOpenWorkOrder: true, description: result.Body.message }));
        }
        reportDWHCreateSale(thunkAPI, state.saleType, 'General Error');
      }
    }
    return result.Body;
  } catch (error) {
    console.info('error', error);
    thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '76', isOpenWorkOrder: true, description: 'create sale - timeout' }));
    reportDWHCreateSale(thunkAPI, state.saleType, 'Timeout');
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const goToEsimQrCodePageAsync = createAsyncThunk('saleJetBlock/goToEsimQrCodePageAsync', async (data, thunkAPI) => {
  const state = thunkAPI.getState().saleJetBlock;
  const selectedLine = data?.selectedLine || state.cellular?.selectedEsimLine;

  if (!selectedLine) {
    return;
  }

  const esimOrder = state.resultByOrders?.find(x => x.orderType === getEsimTypeCode());
  const magicLink = esimOrder?.magicLinkResponse?.find(x => x.cli === selectedLine.phoneNumber);

  if (!magicLink?.tinyUrl) {
    return;
  }

  await buildUrlAndOpenSameWindow(magicLink.tinyUrl);
});

export const getTechnicianTimesAsync = createAsyncThunk('saleJetBlock/getTechnicianTimesAsync', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    thunkAPI.dispatch(setIsCalcSupplyMethod(true));
    await thunkAPI.dispatch(getSalePricesAsync());
    const state = thunkAPI.getState().saleJetBlock;
    const infrastructure = state.addressPage?.selectedEntry?.infrastructure;

    const supplyMethod = state.saleCatalog?.supplyMethods?.find((x) => x.name == 'Technician');
    if (!supplyMethod) {
      thunkAPI.dispatch(
        setErrorPage({ isDisplay: true, id: '53', isOpenWorkOrder: true, description: 'get technician times error: no supplyMethod' })
      );
      thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'get technician times error: no supplyMethod' }));
      return;
    }

    let iipSeq = '';
    if (state.orderType == 'replace') {
      iipSeq = state.userAddressForUpgradePage?.selectedAddress?.iipSeq;
    }
    const params = {
      cityName: state.addressPage.selectedAddress.cityName,
      cityCode: state.addressPage.selectedAddress.citySemel,
      streetCode: state.addressPage.selectedAddress.streetSemel,
      entranceNo: state.addressPage.selectedAddress.entry,
      taskType: supplyMethod.techDescription,
      callId: state.saleType == 'tv' ? '322' : '',
      zipCode: state.addressPage.selectedAddress.zipCode,
      addHours: '3',
      distributionType: state.addressPage.selectedEntry.distributionType,
      infrastructure: infrastructure,
      iipSeq: iipSeq,
      houseNumber: state.addressPage.selectedAddress.home,
      apartment: state.addressPage.selectedAddress.apartment,
    };

    const result = await ProviderManager.getProviderData('getTechnicianTimes', params);
    thunkAPI.dispatch(setSupplyType('technician'));
    thunkAPI.dispatch(setTechnicianPrice(supplyMethod.price));
    thunkAPI.dispatch(goToPage('technicianPage'));

    return result?.Body;
  } catch (error) {
    thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '53', isOpenWorkOrder: true, description: 'get technician times error' }));
    thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'get technician times error' }));
  } finally {
    thunkAPI.dispatch(setIsCalcSupplyMethod(false));
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const getFirstTechnicianTimeAsync = createAsyncThunk('saleJetBlock/getFirstTechnicianTimeAsync', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const state = thunkAPI.getState().saleJetBlock;
    const infrastructure = state.addressPage.selectedEntry?.infrastructure;

    //Checking the package selected for the Infrastructure && Technology && Speed
    let checkPackagesCorrect = await thunkAPI.dispatch(filterOrCheckPackagesCorrect(state.selectedPackage));
    if(checkPackagesCorrect.payload === null){
      let resFilterPackages = await thunkAPI.dispatch(filterOrCheckPackagesCorrect()); //Filter packages
      if(resFilterPackages.payload?.length > 0) {
        thunkAPI.dispatch(setPackageNotValidPopUp(true));
        thunkAPI.dispatch(goToPage('packagesPage'));
        return;
      };
    };


    let taskType = 'התקנת IPTV';
    if (infrastructure == 'BC') {
      taskType = 'התקנת תשתית IBC + טיוי + סופר WIFI';
    }
    if (infrastructure == 'FB' || infrastructure == 'BF') {
      taskType = 'התקנת תשתית סיבים + TV + סופר WIFI';
    }

    const params = {
      cityName: state.addressPage.selectedAddress.cityName,
      cityCode: state.addressPage.selectedAddress.citySemel,
      streetCode: state.addressPage.selectedAddress.streetSemel,
      entranceNo: state.addressPage.selectedAddress.entry,
      taskType: taskType,
      callId: state.saleType == 'tv' ? '322' : '',
      zipCode: state.addressPage.selectedAddress.zipCode,
      addHours: '48',
      distributionType: state.addressPage.selectedEntry.distributionType,
      infrastructure: infrastructure,
      houseNumber: state.addressPage.selectedAddress.home,
      apartment: state.addressPage.selectedAddress.apartment,
    };

    const result = await ProviderManager.getProviderData('getFirstTechnicianTime', params);

    const authenticationState = thunkAPI.getState().authentication;
    if (state.saleType === 'internet' || authenticationState.loginData?.isFullAuthenticated) {
      await thunkAPI.dispatch(prepareSaleAsync());
    } else {
      thunkAPI.dispatch(goToPage('loginPage'));
    }

    return result?.Body;
  } catch (error) {
    thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '53', isOpenWorkOrder: true, description: 'get first technician time error' }));
    thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'get first technician time error' }));
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const filterOrCheckPackagesCorrect = createAsyncThunk('saleJetBlock/filterPackages', async (data, thunkAPI) => {
  const state = thunkAPI.getState().saleJetBlock;
  const infrastructure = state.addressPage.selectedEntry?.infrastructure;
  const technology = state.addressPage.selectedEntry?.technologyType;
  const addressMaxSpeed = isNaN(parseInt(state.addressPage.selectedEntry?.maxSpeed)) ? 0 : parseInt(state.addressPage.selectedEntry?.maxSpeed);
  let packages;

  if(data !== undefined) {
    const selectPackageOfferId = data?.offerId;
    packages = state?.saleBlockData?.salePackages.expandedValue.filter((x)=>{
     return(x.offerID.value === selectPackageOfferId)
   });
  }else {
    packages = state.saleBlockData.salePackages
  }


  const checkTechnologyPackage = (technologyPackages, technology) => {
    let arrayPackage = technologyPackages?.expandedValue ? technologyPackages?.expandedValue : technologyPackages;
    if(technology === "XGSPON"){
      return arrayPackage;
    }
    else{
      return arrayPackage.filter(technologyPackage => {
        const isXgspon = (technologyPackage.isXgspon.value === "XGSPON" || technologyPackage.isXgspon.value === true )? "XGSPON" : "GPON";
        return (isXgspon === "GPON");
      });
    }
  };

  const checkPackageInfrastructure = (packagesTechnology, infrastructure) => {
    const infrastructureEnums = { 0: 'FB', 1: 'BF', 2: 'BC' };
    return packagesTechnology.filter((x) => {
      const infraValues = x.infrastructures.value.map(infra => infrastructureEnums[infra.infrastructure]);
      return (
        (infrastructure === "FB" && infraValues.includes("FB")) ||
        (infrastructure === "BC" && infraValues.includes("BC")) ||
        (infrastructure === "BF" && infraValues.includes("BF"))
      )
    });

  };

  const checkSpeedPackage = (speedPackage, addressMaxSpeed) => {
    return speedPackage.filter((x) => parseInt(x.downloadSpeed.value) <= addressMaxSpeed);
  };

  let validPackage = checkTechnologyPackage(packages, technology);
  validPackage = validPackage ? checkPackageInfrastructure(validPackage, infrastructure) : null;
  validPackage = validPackage ? checkSpeedPackage(validPackage, addressMaxSpeed) : null;

  if(validPackage.length > 0) thunkAPI.dispatch(setSalePackages(validPackage));

  return validPackage;
});


export const createOtp = createAsyncThunk('saleJetBlock/createOtp', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const state = thunkAPI.getState().saleJetBlock;
    const isInternetLoginOtp =
      state.saleType === 'internet' &&
      (state.otpDetails.otpFlow === 'internetPaymentContactOtp' ||
        state.otpDetails.otpFlow === 'internetCustomerInfo');

    if (isInternetLoginOtp) {
      const action = await thunkAPI.dispatch(
        resendOtpStep1({
          phoneNumber: state.otpDetails.otpPhone,
          isText: !data.isVoice,
          guid: state.otpDetails.otpTicketId,
        }),
      );
      if (resendOtpStep1.rejected.match(action) || !action.payload?.Body?.isSuccess) {
        thunkAPI.dispatch(setOtpErrorMsg('ארעה שגיאה, אנא נסה שוב'));
        return action.payload?.Body;
      }
      const resendBody = action.payload?.Body;
      const newTicket = resendBody?.message || resendBody?.step1Ticket;
      if (newTicket) {
        thunkAPI.dispatch(setOtpTicketId({ otpTicketId: newTicket }));
      }
      return resendBody;
    }

    const result = await ProviderManager.getProviderData('createOtp', [state.otpDetails.otpPhone, data.isVoice]);
    return result?.Body;
  } catch (error) {
    thunkAPI.dispatch(setOtpErrorMsg('אירעה שגיאה, אנא נסה שוב'));
  } finally {
    thunkAPI.dispatch(setOtpAttempts());
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const validateOtp = createAsyncThunk('saleJetBlock/validateOtp', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const state = thunkAPI.getState().saleJetBlock;

    if (
      state.saleType === 'internet' &&
      (state.otpDetails.otpFlow === 'internetPaymentContactOtp' ||
        state.otpDetails.otpFlow === 'internetCustomerInfo')
    ) {
      const loginAction = await thunkAPI.dispatch(
        createOtpLoginStep02({
          phoneNumber: state.otpDetails.otpPhone,
          otpCode: data.otpCode,
          guid: state.otpDetails.otpTicketId,
          restrictCode: data.restrictCode || '',
          loginType: rolesKeys.NEWCREDENTIALS,
          idNumber: state.otpDetails.otpIdentity,
          customerEmail: state.otpDetails.customerEmail || '',
          originProcess: '',
        }),
      );

      if (createOtpLoginStep02.rejected.match(loginAction) || !loginAction.payload?.isSuccess) {
        const codeError = parseInt(loginAction.payload?.codeError, 10);
        if (codeError === 36) {
          thunkAPI.dispatch(setOtpRestrictCodeError('יש טעות בקוד, שננסה שוב?'));
          return loginAction.payload;
        }
        // 74 = contact choice flow in full login; treat as success popup path for payment-contact OTP
        if (state.otpDetails.otpFlow === 'internetPaymentContactOtp' && codeError === 74) {
          thunkAPI.dispatch(
            setIdentitySuccessPopup({
              isDisplay: true,
              contactName: '',
            }),
          );
          return loginAction.payload;
        }
        thunkAPI.dispatch(setOtpErrorMsg('הקוד שהוזן אינו תקין, נסה שנית'));
        return loginAction.payload;
      }

      if (state.otpDetails.otpFlow === 'internetPaymentContactOtp') {
        const userDetails = loginAction.payload?.loginData?.userDetails?.LoginData;
        const contactName =
          [userDetails?.FirstName, userDetails?.LastName].filter(Boolean).join(' ').trim() || '';
        thunkAPI.dispatch(
          setIdentitySuccessPopup({
            isDisplay: true,
            contactName,
          }),
        );
        return loginAction.payload;
      }

      // internetCustomerInfo — token is now saved; continue sale checks
      await thunkAPI.dispatch(
        setPersonalInfo({
          ...state.personalInfo,
          identity: state.otpDetails.otpIdentity,
          subscriberNo: state.otpDetails.otpPhone,
        }),
      );
      await thunkAPI.dispatch(checkUserAsync());
      const checkUserState = thunkAPI.getState().saleJetBlock;
      if (checkUserState.checkUserResponse?.isInBlackList) {
        thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '17', isOpenWorkOrder: true, description: 'is in black list error' }));
        thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'internet customer info checkUser: isInBlackList' }));
        return loginAction.payload;
      }
      if (!checkUserState.checkUserResponse?.canPerformJetSale) {
        thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '75', isOpenWorkOrder: true, description: checkUserState.checkUserResponse?.jetSaleReason || '' }));
        thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'internet customer info checkUser: canPerformJetSale' }));
        return loginAction.payload;
      }
      await thunkAPI.dispatch(continueAfterInternetIdentityAsync());
      return loginAction.payload;
    }

    let result;
    try {
      result = await ProviderManager.getProviderData('validateOtp', [
        state.otpDetails.otpPhone,
        state.otpDetails.otpTicketId,
        data.otpCode,
      ]);
    } catch (error) {
      thunkAPI.dispatch(setOtpErrorMsg('הקוד שהוזן אינו תקין, נסה שנית'));
      return;
    }

    if (result?.Header?.ReturnCode != 0) {
      thunkAPI.dispatch(setOtpErrorMsg('הקוד שהוזן אינו תקין, נסה שנית'));
      return result;
    }

    if (state.saleType === 'internet' && state.otpDetails.otpFlow === 'internetCustomerInfoGuest') {
      await thunkAPI.dispatch(
        setPersonalInfo({
          ...state.personalInfo,
          isCustomerExists: false,
          identity: state.otpDetails.otpIdentity,
          subscriberNo: state.otpDetails.otpPhone,
        }),
      );
      await thunkAPI.dispatch(checkUserAsync());
      const checkUserState = thunkAPI.getState().saleJetBlock;
      if (checkUserState.checkUserResponse?.isInBlackList) {
        thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '17', isOpenWorkOrder: true, description: 'is in black list error' }));
        thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'internet guest OTP checkUser: isInBlackList' }));
        return result;
      }
      if (!checkUserState.checkUserResponse?.canPerformJetSale) {
        thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '75', isOpenWorkOrder: true, description: checkUserState.checkUserResponse?.jetSaleReason || '' }));
        thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'internet guest OTP checkUser: canPerformJetSale' }));
        return result;
      }
      if (state.otpDetails.needsPaymentDigits) {
        thunkAPI.dispatch(goToPage('internetPaymentDigitsPage'));
        return result;
      }
      await thunkAPI.dispatch(getTechnicianTimesAsync());
    } else {
      const personalInfo = {
        isCustomerExists: false,
        identity: state.otpDetails.otpIdentity,
        subscriberNo: state.otpDetails.otpPhone,
        firstName: '',
        lastName: '',
      };
      await thunkAPI.dispatch(setPersonalInfo(personalInfo));
      await thunkAPI.dispatch(prepareSaleAsync());
    }

    return result;
  } catch (error) {
    // OTP already validated — do not show "invalid code" for later sale-flow failures
    console.error('[SaleJet] validateOtp post-success error', error);
  } finally {
    thunkAPI.dispatch(setIsSubmit(false));
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const getDeliveryTimeSlots = createAsyncThunk('saleJetBlock/getDeliveryTimeSlots', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());

    const state = thunkAPI.getState().saleJetBlock;
    const selectedAddress = state.delivery?.selectedAddress;
    let supplyMethod = null;


    if(state.saleType == 'cellular'){
      supplyMethod = state.saleCatalog?.orders.find(x => x.orderType == getSimTypeCode())?.supplyMethods.find( x => x.name == 'Delivery' );
    }else {
      thunkAPI.dispatch(setIsCalcSupplyMethod(true));
      await thunkAPI.dispatch(getSalePricesAsync());
      supplyMethod = state.saleCatalog?.supplyMethods?.find((x) => x.name == 'Delivery');
    }

    if (!supplyMethod) {
      thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '20', isOpenWorkOrder: true, description: 'delivery supplyMethod error' }));
      thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'get delivery time Slots error: no supplyMethod' }));
      return;
    }

    let strProducts = state.saleType; //Temporary - Ask Maya what to send
    //   products.map((product, key) => {
    //     strProducts += product.productIdDelivery + '_';
    //   });
    //   strProducts.slice(0, -1);

    const result = await ProviderManager.getProviderData('getDeliverySlots', [
      selectedAddress.cityName,
      selectedAddress.streetName,
      selectedAddress.home,
      strProducts,
    ]);
    if (result?.Body?.length > 0) {
      //await thunkAPI.dispatch(setDeliveryTimeSlots(result.Body));
      thunkAPI.dispatch(setSupplyType('delivery'));
      thunkAPI.dispatch(setDeliveryPrice(supplyMethod.price));
      thunkAPI.dispatch(goToPage('deliveryPage'));
    }
    return result.Body;
  } catch (error) {
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
    thunkAPI.dispatch(setIsCalcSupplyMethod(false));
  }
});

export const createWorkOrder = createAsyncThunk('saleJetBlock/createWorkOrder', async (data, thunkAPI) => {
  try {
    const saleJetBlock = thunkAPI.getState().saleJetBlock;
    thunkAPI.dispatch(showAppLoader());
    if (data?.orderType === 'SALE_NEW_CUSTOMER') {
      const saleType =saleJetBlock.saleType;
      const result = await ProviderManager.getProviderData('createWorkOrder', {
        orderType: data.orderType,
        saleJet: {
          saleType,
        },
      });
      return result?.Body;
    }
   
    const stateForWorkOrder =
      data?.id != null || data?.description
        ? {
            ...saleJetBlock,
            errorPage: {
              ...saleJetBlock.errorPage,
              id: data?.id != null ? parseInt(data.id, 10) : saleJetBlock.errorPage.id,
              description: data?.description ?? saleJetBlock.errorPage.description,
            },
          }
        : saleJetBlock;
    var response = await callOpenWorkOrderForSaleJet(stateForWorkOrder);
    return response;
  } catch (error) {
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const setDefaultConverter = createAsyncThunk('saleJetBlock/setDefaultConverter', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const state = thunkAPI.getState().saleJetBlock;

    const converters = state.saleCatalog?.converters?.filter((x) => x.name == 'PREM');
    if (converters) {
      const data = { name: 'PREM', count: 1 };
      thunkAPI.dispatch(updateConverter(data));
      await thunkAPI.dispatch(getSalePricesAsync());
    }

    thunkAPI.dispatch(reportDWH({ actionType: 'Converters YoN', status: 'Ongoing', messageText: 'Converters YoN Page Button Clicked' }));
    thunkAPI.dispatch(goToPage('convertersPage'));
  } catch (error) {
    thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '75', isOpenWorkOrder: true, description: 'שגיםה - הגדרת ממירים' }));
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const emailIsExist = createAsyncThunk('saleJetBlock/emailIsExist', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('emailIsExist', [data.eMailAddress]);
    const isAvailableEmail = result && result.Body && result.Body.isSuccess;
    return isAvailableEmail;
  } catch (error) {
    return false;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const createLead = createAsyncThunk('saleJetBlock/createLead', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const state = thunkAPI.getState().saleJetBlock;

    let campaignCode = '';
    let campaignName = '';
    let productId = '';
    switch (state.leadType) {
      case 'differentAddress':
        campaignCode = state.saleBlockData.differentAddressCampaignCode;
        campaignName = state.saleBlockData.differentAddressCampaignName;
        productId = state.saleBlockData.differentAddressProductId;
        break;
      case 'noFiber':
        campaignCode = state.saleBlockData.noFiberCampaignCode;
        campaignName = state.saleBlockData.noFiberCampaignName;
        productId = state.saleBlockData.noFiberProductId;
        break;
      case 'hasCopper':
        campaignCode = state.saleBlockData.hasCopperCampaignCode;
        campaignName = state.saleBlockData.hasCopperCampaignName;
        productId = state.saleBlockData.hasCopperProductId;
        break;
      case 'hasMapa':
        campaignCode = state.saleBlockData.mapaCampaignCode;
        campaignName = state.saleBlockData.mapaCampaignName;
        productId = state.saleBlockData.mapaProductId;
        break;
      case 'hasTvAndInternet':
        campaignCode = state.saleBlockData.hasTvAndInternetCampaignCode;
        campaignName = state.saleBlockData.hasTvAndInternetCampaignName;
        productId = state.saleBlockData.hasTvAndInternetProductId;
        break;
      case 'superWifiLead':
        campaignCode = state.saleBlockData.superWifiCampaignCode;
        campaignName = state.saleBlockData.superWifiCampaignName;
        productId = state.saleBlockData.superWifiProductId;
        break;
    }

    const fullName = state.personalInfo.firstName + ' ' + state.personalInfo.lastName;
    const phone = state.personalInfo.subscriberNo;
    const url = encodeURI(window.location.origin + window.location.pathname);
    const bannerId = '';
    const searchTerm = '';
    const adSource = '';
    const isAgreementsCheckBoxActive = false;
    const recaptchaToken = '';
    const description = '';

    const result = await ProviderManager.getProviderData('createLead', [
      recaptchaToken,
      fullName,
      phone,
      campaignCode,
      campaignName,
      productId,
      adSource,
      url,
      bannerId,
      searchTerm,
      isAgreementsCheckBoxActive,
      description
    ]);

    if (result?.Body?.isSuccess) {
      if (state.page == 'addressPage') {
        thunkAPI.dispatch(reportAnalytics({ eventCategory: 'fiber_newsale_process', eventAction: 'visibility_14', eventLabel: 'screen_2' }));
        thunkAPI.dispatch(
          reportDWH({
            actionType: 'Address Not Connected To Fiber',
            status: 'Completed',
            messageText: 'customer created a hot lead about address not connected to fiber',
          })
        );
      }
    }

    return result;
  } catch (error) {
    thunkAPI.dispatch(
      reportDWH({
        actionType: 'Error',
        status: 'Error',
        messageText: 'Lead Error - campaignCode : ' + campaignCode + ', campaignName: ' + campaignName + ', productId: ' + productId,
      })
    );
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});


export const checkWhatsAppActivity = createAsyncThunk('saleJetBlock/checkWhatsAppActivity', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const isWhatsAppActive = await ProviderManager.getProviderData('getSaleWhatsAppActivity', []);
    return isWhatsAppActive;
  } catch (error) {
    return false;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
    thunkAPI.dispatch(setLeadPage('noFiber'));
  }
});

export const getPhoneNumbers = createAsyncThunk('saleJetBlock/getPhoneNumbers', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('getPhoneNumbersSaleJet', []);
    return result.Body;
  } catch (error) {
    return [];
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const getPhoneNumberInfo = createAsyncThunk('saleJetBlock/getPhoneNumberInfo', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const state = thunkAPI.getState().saleJetBlock;
    const phoneNumber = state.cellular.cellularSettingsList?.find(x => x.isSelected)?.phoneNumber;
    const result = await ProviderManager.getProviderData('getPhoneNumberInfo', [phoneNumber]);
    thunkAPI.dispatch(hideAppLoader());
    if (!result.Body.isSuccess) {
      thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '75', isOpenWorkOrder: true, description: 'שגיםה בממשק 1225 לבדיקת מספר קיים' }));
      thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'interface 1225 - check existing phone number' }));
    }
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '75', isOpenWorkOrder: true, description: 'שגיםה בממשק 1225 לבדיקת מספר קיים' }));
    thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'interface 1225 - check existing phone number' }));
    return [];
  }
});

export const reservePhone = createAsyncThunk('saleJetBlock/reservePhone', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const state = thunkAPI.getState().saleJetBlock;
    const phoneNumber = state.cellular.cellularSettingsList?.find(x => x.isSelected)?.phoneNumber;
    const idNumber = state.personalInfo.identity;
    let request = {
      IdNumber: idNumber,
      ListPhoneNumbers: [phoneNumber]
    }

    const result = await ProviderManager.getProviderData('reservePhone', request);
    thunkAPI.dispatch(hideAppLoader());

    if (!result.Body.isSuccess) {
      thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '75', isOpenWorkOrder: true, description: 'שגיםה בממשק 24 לשמירת מספר חדש' }));
      thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'interface 24 - reserve phone number' }));
    }
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '75', isOpenWorkOrder: true, description: 'שגיםה בממשק 24 לשמירת מספר חדש' }));
    thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'interface 24 - reserve phone number' }));
  }
});

export const getPriceSim = createAsyncThunk('saleJetBlock/getPriceSim', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const state = thunkAPI.getState().saleJetBlock;
    const idNumber = state.personalInfo?.identity;
    const bpKey = data.bpKey;

    const result = await ProviderManager.getProviderData('getPriceSim', [idNumber, bpKey]);
    thunkAPI.dispatch(hideAppLoader());

    if (result.Header.ReturnCode != 0) {
      thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '75', isOpenWorkOrder: true, description: 'שגיםה ממשק 835 - מחיר SIM' }));
      thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'interface 835 - get sim esim price' }));
    }

    result.Body.bpKey = bpKey;

    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '75', isOpenWorkOrder: true, description: 'שגיםה ממשק 835 - מחיר SIM\ESIM' }));
    thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'שגיםה ממשק 835 - מחיר SIM\ESIM' }));
  }
});

export const addCellular = createAsyncThunk('saleJetBlock/addCellular', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const state = thunkAPI.getState().saleJetBlock;
    const currentSetting = state.cellular.cellularSettingsList?.find(x => x.isSelected);

    if (currentSetting?.phoneType == "transfer") {
      if (currentSetting?.phoneNumber == '') {
        //TODO: SHOW ERROR MSG
        return;
      }
      else {
        const transferPhoneNumberInfo = await thunkAPI.dispatch(getPhoneNumberInfo());
        if (!transferPhoneNumberInfo.payload.isSuccess) {
          return;
        }

        const { phoneOperatorName } = transferPhoneNumberInfo.payload;
        const currentNetworkOperator = process.env.staticWebSiteUrl?.includes('golan') ? 'GTEL' : 'CELL';
        if (phoneOperatorName === currentNetworkOperator) {
          return;
        }
      }
    }
    else if (currentSetting?.phoneType == "new") {
      if (currentSetting.reservePhoneInfo?.phoneNumber != currentSetting?.phoneNumber) {
        let reservePhoneResponse = await thunkAPI.dispatch(reservePhone());
        if (!reservePhoneResponse.payload.isSuccess) {
          return;
        }
      }
    }

    if (state.cellular.isDisplayDeliveryPage) {
      thunkAPI.dispatch(setIsCalcSupplyMethod(true));
    }

    thunkAPI.dispatch(showAppLoader());
    const salePrices = await thunkAPI.dispatch(getSalePricesAsync());
    thunkAPI.dispatch(hideAppLoader());

    if (salePrices.payload?.successCatalogResult?.isSuccess) {
      const action = currentSetting.change.action == "" ? 'Add' : currentSetting.change.action;
      thunkAPI.dispatch(setCellularSettingList({action: action}));
      if (data.isAdditionalPhoneNumber) {
        thunkAPI.dispatch(resetCellularSettingsPage({ isFullReset: false }));
      }
      else if(data.isChangeSelectedPackage){
        thunkAPI.dispatch(resetCellularSettingsPage({ isFullReset: false, isResetPackage: true }));
        return;
      }
      else if (data.isSaveCellularSetting) {
        return;
      }
      else {
        if (state.flowType == 'existsCustomer') {
          thunkAPI.dispatch(getCustomerAddresses());
        }
        else {
          thunkAPI.dispatch(goToPage('personalInfoPage'));
        }
      }
    }
  } catch (error) {
  }
});

export const getFullPrice = createAsyncThunk('saleJetBlock/getFullPrice', async (data, thunkAPI) => {
  try {

    const addonNotEquipment = data.addonsName?.includes('9600NB') || data.addonsName?.includes('7804NB');
    if (!addonNotEquipment) {
      thunkAPI.dispatch(setIsLoadingShoppingCart(true));
    };

    const state = thunkAPI.getState().saleJetBlock;

    let result = null;
    if(state.saleType == 'cellular'){
      // const request = {
      //   orders: state.saleCatalog.orders
      // }
      result = await ProviderManager.getProviderData('getCellularFullPrice', data);
    }
    else{
      result = await ProviderManager.getProviderData('getFullPrice', data.params);
    }

    thunkAPI.dispatch(setIsLoadingShoppingCart(false));

    if (result?.Header?.ReturnCode != 0) {
      thunkAPI.dispatch(reportDWH({ actionType: 'Error', status: 'Error', messageText: 'interface 835 - get sim esim price' }));
    }

    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(setIsLoadingShoppingCart(false));
  }
});


export const cellularChangePackage = createAsyncThunk('saleJetBlock/cellularChangePackage', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());

    await thunkAPI.dispatch(getSaleCatalogAsync())

    const state = thunkAPI.getState().saleJetBlock;

    if (!state.saleCatalog || Object.keys(state.saleCatalog).length === 0) {
      thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '18521200', isOpenWorkOrder: true, description: 'get sale catalog error' }));
      return;
    }

    const bpKey = state.saleCatalog?.bpKey;
    const isExist = state.cellular.simPriceList.find(x => x.bpKey == bpKey);
    if (!isExist || (!isExist?.sim && !isExist?.esim)) {
      await thunkAPI.dispatch(getPriceSim({bpKey: bpKey}));
    }

    thunkAPI.dispatch(setCellularSetting({ setNewPackage: true }));

    return {};
  } catch (error) {
  }finally{
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const editRemoveCellularItem = createAsyncThunk('saleJetBlock/editRemoveCellularItem', async (data, thunkAPI) => {
  try {

    await thunkAPI.dispatch(editRemoveCellular({phoneNumber: data.phoneNumber, action: data.action}));

    if(data.action == 'Disconnect'){
      thunkAPI.dispatch(showAppLoader());
      const saleCatalog = await thunkAPI.dispatch(getSalePricesAsync());
      thunkAPI.dispatch(hideAppLoader());
      if(saleCatalog.payload.successCatalogResult.isSuccess){
        thunkAPI.dispatch(removeCellularItem({phoneNumber: data.phoneNumber}));
      }
    }
    else if(data.action == 'Change'){
      thunkAPI.dispatch(goToPage('cellularSettingsPage'));
    }

  }catch (error) {
  }
});


function getActionTypeByPage(page) {
  let actionType = "";
  switch (page) {
    case 'addressPage':
      actionType = 'Address Check';
      break;
    case 'deliveryPage':
      actionType = 'Select Delivery Date';
      break;
    case 'pavingFeePage':
      actionType = 'Deployment Fee';
      break;
    case 'premiumPackagesPage':
      actionType = 'Premium Select';
      break;
    case 'technicianPage':
      actionType = 'Select Technician Date';
      break;
    default:
      actionType = "NA";
  }

  return actionType;

}

function reportDWHCreateSale(thunkAPI, saleType, messageText) {
  let actionType = '';
  let status = '';

  switch (saleType) {
    case 'tv':
    case 'app':
      actionType = 'Create TV Order';
      break;
    case 'internet':
      actionType = 'Create Fiber Order';
      break;
    case 'triple':
      actionType = 'Create FiberTV Order';
      break;
  }

  switch (messageText) {
    case 'General Error':
    case 'Timeout':
      status = 'Error';
      break;
    default:
      status = 'Completed';
      break;
  }

  thunkAPI.dispatch(reportDWH({ actionType: actionType, status: status, messageText: messageText }));
}

export const getOrgBenefitsAllocations = createAsyncThunk('saleJetBlock/getOrgBenefitsAllocations', async ({productsDescription, saleType,mode='getPackages'}, thunkAPI) => {
  try {

    const auth = thunkAPI.getState().authentication;
    var isOrgLogin = isOrgEmployeeLogin(auth);
    if(isOrgLogin){
      if(isNullOrEmpty(productsDescription)){

          var result = await thunkAPI.dispatch(getOrgFamilyBenefitsAllocations());
          if(result?.payload){
            productsDescription = result?.payload?.productsDescription || {};
          }
     }

    const productKey = Object.keys(productsDescription || {}).find(
      (key) => key.toLowerCase() === saleType?.toLowerCase(),
    );
    let salesPackages = productsDescription[productKey];
    switch(mode){
      case 'addLine':
        return salesPackages.remaining;
      case 'getPackages':
        salesPackages = salesPackages.salesPackages || [];
        return salesPackages;
      default:
        return null;
    }
    }
  } catch (error) {
  }
});